import cn from 'classnames'

import styles from './Flex.module.scss'
import { IFlexProps } from './Flex.types'

export const Flex = ({
  children,
  gap = 0,
  justifyContent = 'flex-start',
  wrap = false,
  direction = 'column',
  alignItems = 'center',
}: IFlexProps) => {
  return (
    <div
      className={cn(
        styles.flexRoot,
        styles[direction],
        styles[`justify-${justifyContent}`],
        styles[`align-${alignItems}`],
        styles[`gap-${gap}`],
        wrap ? styles.wrap : styles.nowrap
      )}
    >
      {children}
    </div>
  )
}
